export default "__VITE_ASSET__D02b2LKd__"